/**
 * ZENO ERP — SERVICE ENUMS
 * =========================
 * GOVERNED FILE — No raw strings allowed anywhere in service flow.
 * Always import from here.
 */

// ─────────────────────────────────────────────
// SERVICE STATUS
// ─────────────────────────────────────────────
export const SERVICE_STATUS = Object.freeze({
  OPEN:                       "open",
  ASSIGNED:                   "assigned",
  IN_PROGRESS:                "in_progress",
  PARTIAL:                    "partial",
  COMPLETED_PENDING_APPROVAL: "completed_pending_approval",
  CLOSED:                     "closed",
  CANCELLED:                  "cancelled",
});

// ─────────────────────────────────────────────
// JOB TYPES (SM closes with this)
// ─────────────────────────────────────────────
export const SERVICE_JOB_TYPE = Object.freeze({
  PROJECT:    "project",
  AMC:        "amc",
  WARRANTY:   "warranty",
  CHARGEABLE: "chargeable",
  INTERNAL:   "internal",
  OTHER:      "other",
});

export const SERVICE_JOB_TYPE_LABELS = Object.freeze({
  project:    "Project Work",
  amc:        "AMC",
  warranty:   "Warranty",
  chargeable: "Chargeable",
  internal:   "Internal",
  other:      "Other",
});

// ─────────────────────────────────────────────
// TECH ACCEPTANCE
// ─────────────────────────────────────────────
export const TECH_ACCEPTANCE = Object.freeze({
  PENDING:  null,
  ACCEPTED: true,
  REJECTED: false,
});

// ─────────────────────────────────────────────
// COMPLETION TYPE
// ─────────────────────────────────────────────
export const COMPLETION_TYPE = Object.freeze({
  COMPLETE: "complete",
  PARTIAL:  "partial",
});

// ─────────────────────────────────────────────
// COLLECTIONS
// ─────────────────────────────────────────────
export const SERVICE_COLLECTIONS = Object.freeze({
  TASKS:               "service_tasks",
  VISITS:              "service_visits",
  LOGS:                "service_logs",
  DEFECTIVE_TRACKING:  "service_defective_tracking",
  REPORTS:             "service_reports",
});

// ─────────────────────────────────────────────
// OFFLINE KEYS (localStorage)
// ─────────────────────────────────────────────
export const OFFLINE_KEYS = Object.freeze({
  QUEUE:       "zeno_offline_service_queue",  // unified queue key
  // Legacy keys retained for reference — no longer written to
  START_WORK:  "offline_start_work",
  END_JOB:     "offline_end_job",
  PENDING_OPS: "offline_pending_ops",
});

// ─────────────────────────────────────────────
// STATUS UI CONFIG
// ─────────────────────────────────────────────
export const STATUS_UI = Object.freeze({
  [SERVICE_STATUS.OPEN]:                       { label: "Open",              bg: "#f3f4f6", color: "#374151", border: "#d1d5db" },
  [SERVICE_STATUS.ASSIGNED]:                   { label: "Assigned",          bg: "#dbeafe", color: "#1e40af", border: "#93c5fd" },
  [SERVICE_STATUS.IN_PROGRESS]:                { label: "In Progress",       bg: "#fef3c7", color: "#92400e", border: "#fcd34d" },
  [SERVICE_STATUS.PARTIAL]:                    { label: "Partial",           bg: "#fed7aa", color: "#9a3412", border: "#fb923c" },
  [SERVICE_STATUS.COMPLETED_PENDING_APPROVAL]: { label: "Pending Approval",  bg: "#ede9fe", color: "#5b21b6", border: "#a78bfa" },
  [SERVICE_STATUS.CLOSED]:                     { label: "Closed",            bg: "#d1fae5", color: "#065f46", border: "#6ee7b7" },
  [SERVICE_STATUS.CANCELLED]:                  { label: "Cancelled",         bg: "#fee2e2", color: "#991b1b", border: "#fca5a5" },

  // ── Legacy fallback — old Firestore docs only — DO NOT REMOVE ──────────
  "completed": { label: "Completed", bg: "#d1fae5", color: "#065f46", border: "#6ee7b7" },
});

// ─────────────────────────────────────────────
// PRIORITY SORT (for tech dashboard)
// ─────────────────────────────────────────────
export const STATUS_PRIORITY = Object.freeze({
  [SERVICE_STATUS.IN_PROGRESS]:                1,
  [SERVICE_STATUS.PARTIAL]:                    2,
  [SERVICE_STATUS.ASSIGNED]:                   3,
  [SERVICE_STATUS.COMPLETED_PENDING_APPROVAL]: 4,
  [SERVICE_STATUS.OPEN]:                       5,
  [SERVICE_STATUS.CLOSED]:                     6,
  [SERVICE_STATUS.CANCELLED]:                  7,

  // ── Legacy fallback — old Firestore docs only — DO NOT REMOVE ──────────
  "completed": 6,
});
